export var NewCompetitionPhase;
(function (NewCompetitionPhase) {
    NewCompetitionPhase[NewCompetitionPhase["None"] = 0] = "None";
    NewCompetitionPhase[NewCompetitionPhase["Submiting"] = 1] = "Submiting";
    NewCompetitionPhase[NewCompetitionPhase["Submitted"] = 2] = "Submitted";
    NewCompetitionPhase[NewCompetitionPhase["NoDialog"] = 3] = "NoDialog";
})(NewCompetitionPhase || (NewCompetitionPhase = {}));
export var CompetitionEditAction;
(function (CompetitionEditAction) {
    CompetitionEditAction[CompetitionEditAction["Saving"] = 1] = "Saving";
    CompetitionEditAction[CompetitionEditAction["Validation"] = 2] = "Validation";
})(CompetitionEditAction || (CompetitionEditAction = {}));
